export default __webpack_public_path__ + "static/media/ExcludeQuestion.bec1fc7e.svg";